import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { cn } from "@/lib/utils";
function HeaderMenuConsumer({
  isMobile = false,
  closeMobileMenu
}: {
  isMobile?: boolean;
  closeMobileMenu?: () => void;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return null;
  }
  if (isMobile) {
    return <div data-section-id="4787" className="flex flex-col gap-6 items-center justify-center h-full">
        {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} className="text-2xl font-bold uppercase tracking-widest text-foreground hover:text-primary transition-colors" onClick={closeMobileMenu} data-index={i}>
            {item.label}
          </Link>)}
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="gap-10">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-xs font-bold uppercase tracking-widest text-foreground/80 hover:text-primary transition-colors font-sans">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href]') as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute('href');
        if (!href) return;
        let hash = '';
        if (href.startsWith('#')) {
          hash = href;
        } else if (href.startsWith('/') && href.includes('#')) {
          const [path, hashPart] = href.split('#');
          if (path === '/' || path === window.location.pathname) {
            hash = '#' + hashPart;
          }
        }
        if (hash && hash !== '#') {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
            setIsMobileMenuOpen(false);
          }
        }
      }
    };
    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);
  return <header id="hoofdnavigatie" className={cn("sticky top-0 z-50 w-full transition-all duration-500 dark bg-background text-foreground", isScrolled ? "bg-background/80 backdrop-blur-xl border-b border-white/10 py-3 shadow-lg" : "bg-secondary border-b border-transparent py-5")}>
      <div className="container mx-auto px-6 md:px-12 flex items-center justify-between">
        {}
<Link to="/HomePage" className="flex-shrink-0 z-50 flex items-center gap-3">
  <img src="https://finer-monkfish.10web.cloud/wp-content/uploads/2026/03/image_8xrj8zwr.jpg" alt="ZapGO!" className="h-12 w-auto object-contain brightness-100 !rounded-none !shadow-none" />
  <span className="text-2xl font-bold tracking-tighter hidden sm:block">
    <span className="zap-color"></span><span className="go-color"></span>
  </span>
  <style>{`
    .zap-color { color: #ffe838; }
    .go-color { color: #70cf70; }
  `}</style>
</Link>

        {}
        <div className="hidden md:block">
          <MenuProvider menu_id="16" className="header-menu">
            <HeaderMenuConsumer />
          </MenuProvider>
        </div>

        {}
        <button className="md:hidden p-2 text-foreground hover:text-primary transition-colors focus:outline-none z-50" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu">
          {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>

        {}
        <div className={cn("fixed inset-0 bg-background/95 backdrop-blur-2xl z-40 md:hidden transition-transform duration-500 ease-in-out flex flex-col pt-24 px-6", isMobileMenuOpen ? "translate-x-0" : "translate-x-full")}>
          <MenuProvider menu_id="16" className="mobile-menu h-full">
            <HeaderMenuConsumer isMobile closeMobileMenu={() => setIsMobileMenuOpen(false)} />
          </MenuProvider>
        </div>
      </div>
    </header>;
}